import { render } from "./LorealProjectFour.vue?vue&type=template&id=045f49da"
import script from "./LorealProjectFour.vue?vue&type=script&lang=js"
export * from "./LorealProjectFour.vue?vue&type=script&lang=js"

import "./LorealProjectFour.vue?vue&type=style&index=0&id=045f49da&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__